module.exports = __webpack_public_path__ + "img/8.d359e949.jpg";